import { render, staticRenderFns } from "./SOSimplePrice.vue?vue&type=template&id=b90d7752"
import script from "./SOSimplePrice.vue?vue&type=script&lang=ts"
export * from "./SOSimplePrice.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports